import client from './client';

export const epicsApi = {
  // List epics (optionally filter by project)
  async list(params = {}) {
    const { data } = await client.get('/api/epics', { params });
    return data;
  },

  // Get single epic by key
  async get(key) {
    const { data } = await client.get(`/api/epics/${key}`);
    return data;
  },

  // Create new epic
  async create(epic) {
    const { data } = await client.post('/api/epics', epic);
    return data;
  },

  // Update epic
  async update(key, updates) {
    const { data } = await client.patch(`/api/epics/${key}`, updates);
    return data;
  },
};
